module.exports = __webpack_public_path__ + "static/GiftaCard-9fd9b60cbd300b0bec565a2e0d4ffb28.jpg";